var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.20002C11.3635 7.20002 10.753 6.94717 10.3029 6.49708C9.85283 6.04699 9.59998 5.43654 9.59998 4.80002C9.59998 4.1635 9.85283 3.55306 10.3029 3.10297C10.753 2.65288 11.3635 2.40002 12 2.40002C12.6365 2.40002 13.2469 2.65288 13.697 3.10297C14.1471 3.55306 14.4 4.1635 14.4 4.80002C14.4 5.43654 14.1471 6.04699 13.697 6.49708C13.2469 6.94717 12.6365 7.20002 12 7.20002ZM12 14.4C11.3635 14.4 10.753 14.1472 10.3029 13.6971C9.85283 13.247 9.59998 12.6365 9.59998 12C9.59998 11.3635 9.85283 10.7531 10.3029 10.303C10.753 9.85288 11.3635 9.60002 12 9.60002C12.6365 9.60002 13.2469 9.85288 13.697 10.303C14.1471 10.7531 14.4 11.3635 14.4 12C14.4 12.6365 14.1471 13.247 13.697 13.6971C13.2469 14.1472 12.6365 14.4 12 14.4ZM12 21.6C11.3635 21.6 10.753 21.3472 10.3029 20.8971C9.85283 20.447 9.59998 19.8365 9.59998 19.2C9.59998 18.5635 9.85283 17.9531 10.3029 17.503C10.753 17.0529 11.3635 16.8 12 16.8C12.6365 16.8 13.2469 17.0529 13.697 17.503C14.1471 17.9531 14.4 18.5635 14.4 19.2C14.4 19.8365 14.1471 20.447 13.697 20.8971C13.2469 21.3472 12.6365 21.6 12 21.6Z",
    fill: "#8D96B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsIcon);
export default __webpack_public_path__ + "static/media/DotsIcon.e1df07c65670aae4b51b21570c2110c7.svg";
export { ForwardRef as ReactComponent };